export const DEFAULT_LOCALE = 'en';
export const locales = [DEFAULT_LOCALE, 'pl'];
export const LANGUAGE_KEY = 'selectedLanguage';

export const getStoredLocale = (): string => {
  try {
    if (typeof localStorage === 'undefined') return DEFAULT_LOCALE;
    const stored = localStorage.getItem(LANGUAGE_KEY);
    return stored && locales.includes(stored) ? stored : DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
};
